import React from "react";
import "./AboutMe.css";

import img from "./suit_picture.jpg"

// let imgUrl = "https://picsum.photos/800";



function AboutMe() {
  return (
    <div id="aboutme" className="aboutme-container">
      <img src={img} alt="aboutme" />
      <div className="divclass">
        <h1>About Me</h1>

        <div className="about-text">
          <p>
            As a Software Engineer and Web Developer, I am passionate about
            designing and building innovative, scalable, and user-friendly web
            applications. With a strong foundation in Computer Science and
            hands-on experience delivering real-world solutions, I thrive on
            solving complex problems and transforming ideas into impactful
            digital products.
          </p>

          <p>
            I bring expertise across a range of programming languages and
            technologies, including JavaScript, TypeScript, PHP, Java, SQL,
            React.js, Node.js, and Python, along with experience in modern tools
            like AWS, Firebase, Docker, Git, and TensorFlow. My work spans
            front-end development, back-end systems, and AI-driven solutions,
            giving me a well-rounded perspective on software development.
          </p>

          <p>
            I am driven by curiosity and continuous learning, always staying
            up-to-date with emerging technologies and best practices. My goal is
            to create seamless, efficient, and meaningful digital experiences
            while collaborating with teams that value innovation and impact.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutMe;
